import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface GeneralTablesCellsTdCheckmarkSignature {
  Args: {
    cellData: boolean;
  };
}

const GeneralTablesCellsTdCheckmark = <template>
  {{#if @cellData}}
    <PrismIcon @name="circle-checkmark" @size="small" />
  {{else}}
    {{t "general.missing"}}
  {{/if}}
</template> satisfies TOC<GeneralTablesCellsTdCheckmarkSignature>;

export default GeneralTablesCellsTdCheckmark;
